module.exports = __webpack_public_path__ + "images/corillian@2x.fc18f63193c5d2aeee3a04efc3f8136a.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/logos/corillian@2x.png
// module id = 1017
// module chunks = 0